import React from 'react';
import {connect} from 'react-redux';
import { callService, goTo } from '../tools';
import SeguridadForm from '../registro-seguridad/seguridad.frm';

const mapState = (state) => {
	return {
		hashOne: state.registro.hashOne,
		hashTwo: state.registro.hashTwo
	};
};

const mapDispatch = (dispatch) => {
	return {
        loader: (show) => {
            dispatch({"type": "LOADER", "show": show});
        },
        alerta: (sTitulo, sMensaje, fnCerrar) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnCerrar });
		},
		setPaso: (paso) => {
            dispatch({ "type": "CONTRATOS_PASO", "paso": paso});
        },
		registrarDatos(sPassword, sPregunta1, sRespuesta1, sPregunta2, sRespuesta2) {
			dispatch({
				"type": "REGISTRO_SEGURIDAD",
				"password": sPassword,
				"pregunta1": sPregunta1,
				"respuesta1": sRespuesta1,
				"pregunta2": sPregunta2,
				"respuesta2": sRespuesta2
			})
		}
	}
}

class Seguridad extends React.Component{

	close = () => {
		goTo("login");
	}

	componentWillMount = () => {
        let $this = this;
		$this.props.loader(true);
            
        new callService({
            service: 'registro.datosSeguridad',
            secure: true,
            data: {
                hashOne: this.props.hashOne,
                hashTwo: this.props.hashTwo
            }
        }).execute().then((respuesta) => {
            console.log("Respuesta", respuesta);
            $this.props.loader(false);
        }).catch((error) => {
            console.log("Error", error);
            $this.props.loader(false);
            $this.props.alerta("ERROR", error.message.mensaje, $this.close);
        });
	}

	submit = (data) => {
		return new Promise(resolve => {
			this.props.registrarDatos(data.password, data.pregunta1, data.respuesta1, data.pregunta2, data.respuesta2);
			this.props.setPaso(2);
			resolve();
		});
	}

	render() {
		return <SeguridadForm onSubmit={this.submit} />;
	}
}

export default connect(mapState, mapDispatch)(Seguridad);


// WEBPACK FOOTER //
// ./src/registro-seguridad/seguridad.cmpt.js